<template>
    <div>
      <!-- Auswahl Dropdown -->
      <v-row justify="left" class="ma-0 mt-6 pa-0">
        <v-col lg="4" sm="6" xs="10">
          <v-select
            class="mb-0 ml-0 pa-0 black--text"
            @change="setze_auswahl_id_cav_ausgewaehlt(id_cav)"
            outlined
            :items="arbeitsanweisungenauswahl"
            v-model="id_cav"
            item-key="id_cav"
            item-text="themenbereich"
            item-value="id_cav"
            label="wähle Anweisung"
          />
        </v-col>
  
        <v-col lg="4" sm="6" xs="2">
          <template v-if="id_cav_ausgewaehlt !== ''">
            <v-btn
              class="ma-3"
              rounded
              color="gray"
              elevation="5"
              small
              @click="erzeuge_ausgewaehlte_arbeitsanweisung"
            >
              erstellen
            </v-btn>
          </template>
        </v-col>
      </v-row>
  
      <!-- Einleitungstitel -->
      <v-container v-if="arbeitsanweisung.length > 0" class="mt-6 px-4 py-2" style="border: 1px solid #ccc; border-radius: 8px; max-width: 960px; margin: 0 auto; padding-left: max(16px, 4vw); padding-right: max(16px, 4vw);">
        <v-row>
          <v-col cols="12">
            <h2 class="text-subtitle-1 font-weight-medium primary--text mb-1">{{ arbeitsanweisung[0].titel }}</h2>
            <p class="text-body-2 font-italic grey--text text--darken-1 mt-0">{{ arbeitsanweisung[0].beschreibung_ueberschrift }}</p>
          </v-col>
        </v-row>
      </v-container>
  
  <!-- Dynamische Anzeige -->
      <v-container v-if="arbeitsanweisung.length > 0" class="mt-10" style="max-width: 700px; margin: 0 auto;">
        <div v-for="(gruppe, index) in gruppierteAnweisungen" :key="index">
          <v-row class="mt-4 mb-2">
            <v-col cols="12" class="d-flex align-center justify-space-between">
              <h3 class="text-h6 font-weight-bold" style="color: #2c3e50;">
                {{ index + 1 }}.) {{ gruppe.infotext }}
              </h3>
              <div style="min-width: 150px; max-width: 150px;"></div>
            </v-col>
          </v-row>
  
          <div v-for="(feldGruppe, i) in gruppiereNachTextVorlage(gruppe.eintraege)" :key="i">
            <v-row>
              <v-col cols="12">
                <div class="ml-4 font-weight-medium text-subtitle-1 mb-2 mt-4" style="color: #555;">{{ feldGruppe.text_vorlage }}</div>
              </v-col>
            </v-row>
  
            <template v-if="feldGruppe.eintraege[0].auswahl === 'Radio'">
              <v-row>
                <v-col cols="12">
                  <v-radio-group class="ml-6" style="margin-top: -4px; margin-bottom: 4px; padding-left: 4px;"
                    :value="radioGruppenModel[feldGruppe.text_vorlage]"
                    @change="val => handleRadioChange(val, feldGruppe.eintraege)"
                    row
                  >
                    <v-radio
                      v-for="(eintrag, j) in feldGruppe.eintraege"
                      :key="j"
                      :label="eintrag.text_feld"
                      :value="eintrag.id_caefv"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
            </template>
  
            <template v-else>
              <v-row v-for="(eintrag, j) in feldGruppe.eintraege" :key="j" class="mb-2">
                <v-col cols="12" class="d-flex align-center" style="gap: 12px; padding-left: 32px;">
                  <span v-if="eintrag.text_feld" style="min-width: 180px; display: inline-block; font-size: 0.9rem; color: #666; margin-left: 16px;">{{ eintrag.text_feld }}</span>
                  <div style="flex: 1;">
                    <div>
                      <template v-if="eintrag.auswahl === 'Checkbox'">
                        <div class="d-flex align-center" style="margin-left: 4px;">
                          <v-checkbox
    :input-value="eintrag.eingabe_checkbox === 'True'"
    @change="value => { eintrag.eingabe_checkbox = value ? 'True' : 'False'; function_wert_eintragen('eingabe_checkbox', eintrag); }"
    class="d-block"
    style="margin: 0 auto; max-width: 150px;"
  />
                        </div>
                      </template>
  
                      <template v-else-if="eintrag.auswahl === 'Textfeld'">
                        <v-text-field
                          v-model="eintrag.eingabe_text"
                          dense
                          outlined
                          hide-details
                          style="min-width: 150px; max-width: 150px;"
                          @change="function_wert_eintragen('eingabe_text', eintrag)"
                        />
                      </template>
  
                      <template v-else-if="eintrag.auswahl === 'Datumsfeld'">
                        <v-text-field
                          v-model="eintrag.eingabe_text"
                          dense
                          outlined
                          hide-details
                          style="min-width: 150px; max-width: 150px;"
                          @change="function_wert_eintragen('eingabe_text', eintrag)"
                        />
                      </template>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </template>
          </div>
  
          <v-divider class="my-4"></v-divider>
        </div>
  
        <v-row v-if="bestätigung_anzeige">
          <v-col cols="12" class="text-center">
            <v-alert type="success" dense text>
              Die Eingaben wurden erfolgreich gespeichert
            </v-alert>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="text-right">
            <v-btn @click="abschliessen" color="primary">Abschließen</v-btn>
          </v-col>
        </v-row>

      </v-container>
  
      <v-dialog v-model="dialogLöschen" max-width="400">
        <v-card>
          <v-card-title class="text-h6">Leere Anweisung löschen?</v-card-title>
          <v-card-text>
            Es wurden keine Eingaben gemacht. Möchten Sie die Anweisung wirklich löschen?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="dialogLöschen = false">Abbrechen</v-btn>
            <v-btn color="red" text @click="loescheLeereAnweisung">Löschen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import ArbeitsanweisungenService from '../services/ArbeitsanweisungenService';
  
  export default {
    data() {
      return {
        dialogLöschen: false,
        bestätigung_anzeige: false,
        id_caev_sar: null,
        arbeitsanweisungenauswahl: [],
        arbeitsanweisung: [],
        id_cav_ausgewaehlt: '',
        current_user_id: '',
        id_cav: '',
        id_vorgang:'',
        selected_id_sar: localStorage.id_sar_ausgewaehlt_global,
        radioGruppenModel: {},
      };
    },
    computed: {
      gruppierteAnweisungen() {
        const gruppen = {};
        this.arbeitsanweisung.forEach((eintrag) => {
          if (!gruppen[eintrag.id_caiv]) {
            gruppen[eintrag.id_caiv] = {
              infotext: eintrag.infotext,
              eintraege: [],
            };
          }
          gruppen[eintrag.id_caiv].eintraege.push(eintrag);
        });
        return Object.values(gruppen);
      },
    },
    methods: {
      async loescheLeereAnweisung() {
        const id_vorgang = this.arbeitsanweisung[0]?.id_vorgang;
        const id_user = this.current_user_id;
        try {
          await ArbeitsanweisungenService.loesche_arbeitsanweisung({ id_vorgang, id_user });
          this.dialogLöschen = false;
          this.arbeitsanweisung = [];
          this.bestätigung_anzeige = true;
          setTimeout(() => {
            this.bestätigung_anzeige = false;
          }, 3000);
        } catch (error) {
          console.error('Fehler beim Löschen:', error);
        }
      },
      async erzeuge_ausgewaehlte_arbeitsanweisung() {
        const credentials = {
          id_cav_ausgewaehlt: this.id_cav_ausgewaehlt,
          selected_id_sar: this.selected_id_sar,
        };
        try {
          const response = await ArbeitsanweisungenService.erzeuge_ausgewaehlte_arbeitsanweisung(credentials);
          if (response && response.output && response.output.answer) {
          this.arbeitsanweisung_anzeigen(response.output.answer);
          this.dialogLöschen = false;
          }
        } catch (error) {
          console.error('Fehler beim Erzeugen der Anweisung:', error);
        }
      },
     handleRadioChange(val, eintraege) {
    const selected = eintraege.find(e => e.id_caefv === val);
    if (selected) {
      this.radioGruppenModel[selected.text_vorlage] = val;
      this.function_wert_eintragen('eingabe_radio', selected);
  
      eintraege.forEach(e => {
        if (e.id_caefv !== val) {
          const updatePayload = {
            wert: 0,
            feld: 'eingabe_radio',
            id_caef_sar: e.id_caef_sar,
            tabelle: 'tbl_check_arbeits_eingabe_felder_sar'
          };
          ArbeitsanweisungenService.update_arbeitsanweisungen(updatePayload)
            .then(() => console.log(`Radio abgewählt: ${e.id_caef_sar}`))
            .catch(err => console.error('Fehler beim Zurücksetzen:', err));
        }
      });
    }
  },
  
      gruppiereNachTextVorlage(eintraege) {
        const gruppen = {};
        eintraege.forEach(eintrag => {
          const key = eintrag.text_vorlage || 'kein Titel';
          if (!gruppen[key]) {
            gruppen[key] = {
              text_vorlage: key,
              eintraege: []
            };
          }
          gruppen[key].eintraege.push(eintrag);
        });
        return Object.values(gruppen);
      },
  
      async arbeitsanweisung_anzeigen(id_vorgang) {
        this.id_vorgang = id_vorgang;
        this.dialogLöschen = false;
        const credentials = {
          id_vorgang: this.id_vorgang,
          selected_id_sar: this.selected_id_sar,
        };
        const response = await ArbeitsanweisungenService.zeige_ausgewaehlte_arbeitsanweisung(credentials);
        this.arbeitsanweisung = response.recordset;
  
        // Radio-Gruppen vorbereiten
        this.radioGruppenModel = {};
        this.arbeitsanweisung.forEach(eintrag => {
          if (eintrag.auswahl === 'Radio' && eintrag.eingabe_radio === '1') {
            const key = eintrag.text_vorlage || 'kein Titel';
            this.radioGruppenModel[key] = eintrag.id_caefv;
          }
        });
      },
  
      setze_auswahl_id_cav_ausgewaehlt(id_cav) {
        this.id_cav_ausgewaehlt = id_cav;
      },
  
      async zeige_anweisungen_auswahl() {
        try {
          const response = await ArbeitsanweisungenService.auswahl_arbeitsanweisungen('');
          this.arbeitsanweisungenauswahl = response.recordset;
        } catch (error) {
          console.error('Fehler beim Laden der Auswahl:', error);
        }
      },
      zum_login() {
        this.$router.push('/login');
      },
      function_wert_eintragen(feldtyp, eintrag) {
        this.id_caev_sar = eintrag.id_caef_sar;
        this.dialogLöschen = false;
        let wert = '';
        if (feldtyp === 'eingabe_text') {
        wert = eintrag.eingabe_text;
        } else if (feldtyp === 'eingabe_checkbox') {
        wert = eintrag.eingabe_checkbox ? 'True' : 'False';
        } else if (feldtyp === 'eingabe_radio') {
        wert = 1;
        }
              const updatePayload = {
          wert: wert,
          feld: feldtyp,
          id_caef_sar: eintrag.id_caef_sar,
          tabelle: 'tbl_check_arbeits_eingabe_felder_sar'
        };
  
        ArbeitsanweisungenService.update_arbeitsanweisungen(updatePayload)
          .then(() => {
            console.log('Wert erfolgreich gespeichert');
          })
          .catch(err => {
            console.error('Fehler beim Speichern:', err);
          });
      },

      async abschliessen() {
            if (!this.arbeitsanweisung || this.arbeitsanweisung.length === 0) return;

            this.dialogLöschen = false;

            const id_vorgang = this.arbeitsanweisung[0]?.id_vorgang;
            const id_user = this.current_user_id;
// 
//             const istEtwasGeändert = this.arbeitsanweisung.some(eintrag => {
//               return (
//                 (eintrag.eingabe_text && eintrag.eingabe_text.trim() !== '') ||
//                 (eintrag.eingabe_checkbox && eintrag.eingabe_checkbox !== 'False') ||
//                 (eintrag.eingabe_radio && eintrag.eingabe_radio !== '0')
//               );
//             });
// 
//             if (!istEtwasGeändert) {
//               this.dialogLöschen = true;
//               return;
//             }

            try {
              await ArbeitsanweisungenService.schliesse_arbeitsanweisung_ab({ id_vorgang, id_user });
              this.bestätigung_anzeige = true;
              this.dialogLöschen = false;
              setTimeout(() => {
                this.bestätigung_anzeige = false;
                this.arbeitsanweisung = [];
              }, 1000);
            } catch (error) {
              console.error('Fehler beim Abschließen:', error);
            }
      }
,



    },
    created() {
      this.zeige_anweisungen_auswahl();
      this.current_user_id = this.$store.getters.getUserId;
      
    },
  };
  </script>
  
  <style scoped>
  </style>
  